import {
  HTTP_UPDATEFORECASTLIST_FETCHING,
  HTTP_UPDATEFORECASTLIST_SUCCESS,
  HTTP_UPDATEFORECASTLIST_FAILED,
} from "./../../Constants";

const initialState = {
  result: [],
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_UPDATEFORECASTLIST_FETCHING:
      return { ...state, result: [], isLoading: true, isError: false };
    case HTTP_UPDATEFORECASTLIST_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_UPDATEFORECASTLIST_FAILED:
      return { ...state, result: [], isLoading: false, isError: true };
    default:
      return state;
  }
};
